/**
 * Quais números a paginação mostra: a primeira, a última e a vizinhança da
 * atual, com "…" no buraco. Até sete posições, para caber num painel de 340 px
 * sem quebrar a linha: "1 … 4 5 6 … 20".
 */
export type PosicaoDaPaginacao = number | 'reticencias';

const POSICOES = 7;

export function paginasVisiveis(pagina: number, total: number): PosicaoDaPaginacao[] {
  if (total <= POSICOES) return Array.from({ length: total }, (_, i) => i + 1);

  // Perto de uma das pontas, a ponta inteira aparece e só o outro lado encolhe.
  if (pagina <= 4) return [1, 2, 3, 4, 5, 'reticencias', total];
  if (pagina >= total - 3) {
    return [1, 'reticencias', total - 4, total - 3, total - 2, total - 1, total];
  }
  return [1, 'reticencias', pagina - 1, pagina, pagina + 1, 'reticencias', total];
}
